import * as React from 'react';
import { Field } from 'formik';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const { jobTypes, fundTypeNames, aumRangeNames } = require('buyside/util/constantsFromRails.json');
import EmployerAutocomplete from 'buyside/components/presentation/EmployerAutocomplete/EmployerAutocomplete';
import { AllFormikProps } from 'interfaces/userApplication/userApplication';

import styles from '../pageStyles.scss';

export type UnemployedProps = Pick<
  AllFormikProps,
  'setFieldValue' | 'setFieldError' | 'initialValues' | 'values'
>;

const Unemployed: React.FunctionComponent<UnemployedProps> = ({
  setFieldError,
  setFieldValue,
  initialValues,
  values
}): React.ReactElement => (
  <>
    <h4>Tell us about your most recent employment</h4>
    <div className={styles.inputField}>
      <EmployerAutocomplete
        analyticsTag="application-unemployed-most-recent-employer”"
        label="Most Recent Employer"
        name="employerName"
        placeholder="Begin Typing..."
        setFieldValue={setFieldValue}
        setFieldError={setFieldError}
      />
    </div>
    <div className={styles.inputField} data-heap="application-unemployed-job-role">
      <Field component={InputField} label="Role" name="title" options={jobTypes} type="select" />
    </div>
    <div className={styles.inputFieldHalf} data-heap="application-unemployed-firm-type">
      <Field
        component={InputField}
        label="Firm Type"
        name="employerFundType"
        options={fundTypeNames}
        type="select"
        disabled={
          Boolean(initialValues?.employerFundType) &&
          initialValues?.employerName === values?.employerName &&
          fundTypeNames.includes(initialValues?.employerFundType)
        }
      />
    </div>
    <div className={styles.inputFieldHalf} data-heap="application-unemployed-aum-firm-range">
      <Field
        component={InputField}
        label="AUM Range of Firm"
        name="employerAumRange"
        options={aumRangeNames}
        type="select"
        disabled={
          Boolean(initialValues?.employerAumRange) &&
          initialValues?.employerName === values?.employerName &&
          aumRangeNames.includes(initialValues?.employerAumRange)
        }
      />
    </div>
  </>
);

export default Unemployed;
